import axios from 'axios';

export const getPractice = (practiceId) => (
	axios.get(`/provider_practices/${practiceId}`)
);

export const updatePractice = (practice) => (
	axios.put(`/provider_practices/${practice.id}`, practice)
);
